/* eslint-disable @hakio/no-untranslated-terminology -- flag panel copy is internal (staff-only), not tenant-facing */
import { Badge } from "~/components/design-system/components"
import { Tooltip } from "~/components/reusable/Tooltip"
import { api } from "~/utils/api"
import { ENVIRONMENT_LABELS } from "~/features/feature-flags/client/model/labels"

/** Which environment's flags the panel shows and changes: this server's own. */
export function EnvironmentBadge() {
  const { data } = api.featureFlagsPanel.overview.useQuery()
  if (!data) return null
  const { environment } = data
  return (
    <Tooltip
      title={`Flags shown and changed here are ${ENVIRONMENT_LABELS[environment]}'s. Every environment keeps its own.${environment === "test" ? " Test covers local, dev and feature branches." : ""}`}
      className="max-w-[50ch]"
    >
      <Badge variant="neutral" size="sm">
        {ENVIRONMENT_LABELS[environment]}
      </Badge>
    </Tooltip>
  )
}
